import React, { useCallback, useRef, useEffect, useState } from 'react'
/** @jsx jsx */
import { css, jsx } from '@emotion/core'
import { BoxClass, NodeById } from '../../../helper/classes'
import SelectPartOfTree from '../../commonInterface/selectPartOfTree'
import { Button, ButtonGroup, Code, Tooltip } from '@blueprintjs/core'
import { defer } from 'lodash'
import { globalOnDemandVars } from '../../../helper/context'
import { comboTextByOS } from '../../../helper/functions'
import { OverlayProps } from '../../../helper/configs'
import { useTranslation } from 'react-i18next'

export function SearchAddOn ({ withInputFocus, forDialog, setDialogOpen }) {
  const selectRef = useRef(null)
  const { t } = useTranslation()

  const [tooltipOpen, setTooltipOpen] = useState(false)

  const onClick = useCallback(
    () => {
      const nodeDataArray = selectRef.current.getSelectedNodeData()
      nodeDataArray.forEach(({ node }) => {
        const nodeById = new NodeById(node.id)
        defer(() => {
          nodeById.onClick()
        })
      })
      selectRef.current.clearSelectedNodeData()

      setTooltipOpen(false)
      setDialogOpen && setDialogOpen(false)
    }
    ,
    [setDialogOpen]
  )

  useEffect(() => {
    if (withInputFocus) { selectRef.current.focus() }
  }, [withInputFocus])

  useEffect(() => {
    globalOnDemandVars.set_focusSearchInput(() => {
      selectRef.current.focus()
      return selectRef.current.focus
    })
    return () => {
      globalOnDemandVars.set_focusSearchInput(() => false)
    }
  }, [])

  const onClick1 = useCallback(
    () => {
      globalOnDemandVars.set_mosaicValue(null)
      defer(() => {
        onClick()
      })
    }
    ,
    [onClick]
  )
  const onKeyDown = useCallback(
    (e) => {
      if (e.altKey && e.keyCode === 79) {
        onClick()
        selectRef.current.blur()
      } else if (e.altKey && e.keyCode === 67) {
        onClick1()
        selectRef.current.blur()
      }
    }
    ,
    [onClick, onClick1]
  )

  const onFocus = useCallback(
    () => { setTooltipOpen(true) },
    []
  )
  const onBlur = useCallback(
    () => { setTooltipOpen(false) },
    []
  )
  return (
    <div css={css`margin: 20px;`} onKeyDown={onKeyDown} onFocus={onFocus} onBlur={onBlur}>
      <Tooltip {...OverlayProps} isOpen={tooltipOpen} targetTagName={'div'} content={(
        <div>
          Search: <Code>{comboTextByOS('mod + f')}</Code>
          <br />
          Open: <Code>alt + o</Code>
          <br />
          Open & Close Others: <Code>alt + c</Code>
        </div>
      )}>
        <div>
          <SelectPartOfTree ref={selectRef} placeholder={`Search Nodes (${comboTextByOS('mod + f')} Anywhere)`} lazyData />
          <br />
          <ButtonGroup fill>
            <Button text={t('Open')} title={'alt + o'} onClick={onClick} />
            <Button text={t('& Close Others')} title={'alt + c'} onClick={onClick1} />
          </ButtonGroup>
        </div>
      </Tooltip>
    </div>
  )
}

const SearchAddOnBoxClass = new BoxClass(SearchAddOn, 'Search', null, 1, { order: 2.5, onlyForTheseLocations: ['/organizing', '/sharing'], inSharingMode: true })

export default SearchAddOnBoxClass
